module.exports = __webpack_public_path__ + "static/img/FishermenGold.7eb28ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/FishermenGold.png
// module id = 3mSF
// module chunks = 1